import personal from './personal'

export {
    personal
}